export var urlknowledgeList = '/api/XOrg/BookMaterial/knowledgeList';
export var urladdKnowledge = '/api/XOrg/BookMaterial/addKnowledge';
export var urlreviseKnowledge = '/api/XOrg/BookMaterial/reviseKnowledge';
export var urlDeleteKnowledge = '/api/XOrg/BookMaterial/deleteKnowledge';
import http from 'lib/http'; // 获取题库知识点列表

export function GetKnowledgeList(courseId, IsTest) {
  return http.post(urlknowledgeList, {
    courseId: courseId,
    IsTest: IsTest
  });
} // 添加题库知识点

export function AddKnowledge(courseId, knowledgeName) {
  return http.post(urladdKnowledge, {
    courseId: courseId,
    knowledgeName: knowledgeName
  });
} //  添加题库知识点名称

export function ReviseKnowledge(knowledgeId, knowledgeName) {
  return http.post(urlreviseKnowledge, {
    knowledgeId: knowledgeId,
    knowledgeName: knowledgeName
  });
} //  删除题库知识点

export function DeleteKnowledge(knowledgeId, courseId) {
  return http.post(urlDeleteKnowledge, {
    knowledgeId: knowledgeId,
    courseId: courseId
  });
}